function NoAttempted() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="337"
			height="337"
			fill="none"
			viewBox="0 0 337 337"
		>
			<circle cx="168.5" cy="168.5" r="168.5" fill="#FFEFCC"></circle>
			<g clipPath="url(#clip-na)">
				<path
					fill="#D78C74"
					d="M267.938 139.937c-1.945 2.003-.471 6.187-6.484 8.898-6.012 2.71-7.368 7.248-7.368 7.248l15.562-4.007s3.654-5.363 3.359-9.723c-.294-4.243-3.124-4.42-5.069-2.416zM75.127 141.704c-2.004-2.239-3.713-3.771-4.833-5.893-1.12-2.121-5.305-.412-4.539 4.479.708 4.891 4.952 7.248 6.779 7.602 1.768.294 9.254-1.532 9.254-1.532s-4.656-2.416-6.66-4.656z"
				></path>
				<path
					fill="#6D7DB3"
					d="M192.311 169.047s-7.545 13.141 19.098 57.867c31.123 52.269 54.053 34.06 54.053 34.06l4.951-11.609s-26.997-49.381-39.729-64.879c-19.275-23.395-38.373-15.439-38.373-15.439z"
				></path>
				<path
					fill="#22356B"
					d="M229.092 182.777c0 .118-.059.236-.059.413 2.063 2.769 3.95 5.716 5.659 8.721 1.768 1.768 3.419 3.654 5.069 5.539-3.419-5.185-6.543-9.723-9.136-12.846a15.766 15.766 0 00-1.533-1.827zM261.513 250.249c-12.614-2.534-37.194-22.392-47.51-42.958-3.478-6.895-5.776-3.772-5.835-11.491 0-.589.059-1.179.176-1.709-2.475-.589-4.951-1.355-7.368-2.062-2.24-.649-4.538-1.12-6.837-1.591 2.711 8.721 7.839 20.624 17.271 36.476 31.123 52.269 54.053 34.06 54.053 34.06l4.951-11.609s-.648-1.119-1.709-3.123c-1.061 2.711-3.537 4.773-7.192 4.007z"
					opacity="0.04"
				></path>
				<path
					fill="#B6BDCE"
					d="M263.458 222.848s7.545-17.914-11.494-11.02c-12.85 4.655-20.159 25.457-14.265 40.778 5.954 15.321 36.723 21.627 35.368-9.075-.767-19.328-9.609-20.683-9.609-20.683z"
				></path>
				<path
					fill="#6D7DB3"
					d="M106.546 184.545c-12.968 15.321-39.73 64.879-39.73 64.879l4.952 11.609s22.104 17.03 53.227-35.239c26.644-44.726 19.452-57.278 19.452-57.278s-19.982-5.244-37.901 16.029z"
				></path>
				<path
					fill="#22356B"
					d="M109.08 226.796c-6.484 11.197-18.568 25.103-32.833 17.207-.943-.53-1.768-1.178-2.416-2.003-.06 0-.118.059-.118.059-1.12.412-2.122.589-3.066.471a1116.593 1116.593 0 00-3.772 6.836l4.951 11.608s22.105 17.03 53.228-35.238c11.966-20.095 17.094-33.707 19.157-42.605-7.722 6.305-16.033 11.668-24.992 15.675-1.887 9.782-5.011 19.151-10.139 27.99z"
					opacity="0.04"
				></path>
				<path
					fill="#B6BDCE"
					d="M85.207 211.887c-18.98-6.953-11.495 11.02-11.495 11.02s-8.841 1.355-9.667 20.742c-1.355 30.702 29.473 24.396 35.368 9.075 5.953-15.38-1.356-36.181-14.206-40.837z"
				></path>
				<path
					fill="#D78C74"
					d="M183.94 156.555c-9.844.471-19.747.766-29.65.294l-.884 20.625c.472 5.598 10.375 7.366 18.096 7.484 7.663.118 15.267-1.473 14.796-7.071l-2.358-21.332z"
				></path>
				<path
					fill="#3D4041"
					d="M188.302 329.802L180.875 342h8.783l6.896-12.198h-8.252z"
				></path>
				<path
					fill="#363C42"
					d="M120.693 329.33s-1.061 6.246-.884 12.67h86.944l.354-14.909-86.414 2.239z"
				></path>
				<path
					fill="#D78C74"
					d="M141.029 176.354v18.916h56.293v-20.802c-16.917-4.95-39.965-4.95-56.293 1.886z"
				></path>
				<path
					fill="#DFE5EA"
					d="M190.661 180.007c-4.951 4.184-13.911 5.422-23.46 5.54-12.084.176-17.566-2.416-19.688-11.668-4.008.707-14.206 3.948-19.865 7.543V342h76.099V185.606c-4.303-2.063-8.665-3.831-13.086-5.599z"
				></path>
				<path
					fill="#6D7DB3"
					d="M161.069 189.966c-.531-2.534-7.133-13.377-8.783-20.389-7.25 0-14.206-5.716-27.881 5.893-11.789 9.959-8.724 39.835-9.667 72.776-.944 34.237-1.002 32.115-5.129 93.812h43.325c-1.297-52.681 7.427-144.785 8.135-152.092zM219.662 203.755c0-3.182 5.954-27.755-16.445-35.298-8.076-1.885-15.916 2.888-17.507 2.475-1.415 8.309-1.238 7.366-11.2 18.445-.884 9.134-7.781 79.965-7.191 152.622h54.171c0-37.065-1.887-116.146-1.828-138.244z"
				></path>
				<path
					fill="#002A3D"
					d="M147.452 173.526s-3.654 16.499 0 23.689c0 0 .944-10.313 5.482-8.545 3.007 1.179 5.954 5.48 7.663 8.191.236-3.595.413-6.011.472-6.894-.472-2.475-7.663-9.37-9.549-16.206-2.358-.353-4.068-.235-4.068-.235z"
					opacity="0.08"
				></path>
				<path
					fill="#7588BC"
					d="M145.45 285.135c2.063-44.432 8.901-96.583 9.844-103.654-.177-.295-.413-.589-.589-.884l-2.83-.412c-.059.589-7.781 57.042-10.021 104.773-1.119 23.866-1.119 43.43-.825 57.042h3.596c-.295-13.553-.295-32.999.825-56.865zM179.224 285.37c.118-49.853 6.013-103.065 6.072-103.595l-2.181-.236c-.472.413-1.002.825-1.533 1.296-.943 8.899-5.835 57.101-5.953 102.535-.059 23.806.589 42.958 1.355 56.629h3.596c-.707-13.612-1.415-32.705-1.356-56.629z"
				></path>
				<path
					fill="#002A3D"
					d="M191.78 173.525s-1.179-.059-2.83.118c-1.591 6.6-5.128 5.834-14.441 16.146-.118 1.12-.59 4.655-.825 8.898 3.065-3.182 10.079-8.957 12.614-9.959 4.539-1.767 5.482 8.545 5.482 8.545 3.654-7.248 0-23.748 0-23.748z"
					opacity="0.08"
				></path>
				<path
					fill="#7588BC"
					d="M121.577 206.289l-1.827 3.772 31.3-5.245-.531-3.536-28.942 5.009zM154.174 166.159s-2.24 1.179-7.192 7.955c-4.951 6.718-.471 20.684-.471 20.684s.766-3.3 2.416-8.839c2.417-8.132 12.143 3.948 12.143 3.948s.531-5.716-2.829-9.193c-5.6-5.716-4.067-14.555-4.067-14.555z"
				></path>
				<path
					fill="#fff"
					d="M154.174 166.159s-.177.059-.472.295c-2.711 5.48-3.3 11.078-1.709 16.735 3.773.118 9.078 6.718 9.078 6.718s.53-5.716-2.83-9.193c-5.6-5.716-4.067-14.555-4.067-14.555z"
					opacity="0.12"
				></path>
				<path
					fill="#B0B5C1"
					d="M151.993 252.548c-1.356 0-2.417.943-2.417 2.121 0 1.179 1.061 2.122 2.417 2.122 1.356 0 2.417-.943 2.417-2.122-.059-1.178-1.12-2.121-2.417-2.121zM154.409 223.613c-1.356 0-2.417.943-2.417 2.122 0 1.178 1.061 2.121 2.417 2.121 1.356 0 2.417-.943 2.417-2.121-.059-1.179-1.12-2.122-2.417-2.122zM149.28 282.482c-1.356 0-2.417.943-2.417 2.122 0 1.178 1.061 2.121 2.417 2.121 1.356 0 2.417-.943 2.417-2.121 0-1.179-1.12-2.122-2.417-2.122zM148.397 307.645c-1.356 0-2.417.942-2.417 2.121 0 1.178 1.061 2.121 2.417 2.121 1.356 0 2.417-.943 2.417-2.121-.059-1.179-1.12-2.121-2.417-2.121zM148.397 333.69c-1.356 0-2.417.943-2.417 2.122 0 1.178 1.061 2.121 2.417 2.121 1.356 0 2.417-.943 2.417-2.121-.059-1.179-1.12-2.122-2.417-2.122zM156.471 198.039c-1.355 0-2.416.943-2.416 2.121 0 1.179 1.061 2.122 2.416 2.122 1.356 0 2.417-.943 2.417-2.122 0-1.178-1.12-2.121-2.417-2.121z"
				></path>
				<path
					fill="#7588BC"
					d="M184.941 164.745s.649 5.127-2.357 11.845c-1.946 4.419-7.781 6.894-8.135 13.494 0 0 13.381-12.198 15.798-4.066 1.65 5.539 2.416 8.839 2.416 8.839s4.48-13.966-.471-20.683c-4.893-6.777-7.251-9.429-7.251-9.429z"
				></path>
				<path
					fill="#fff"
					d="M184.941 164.745s.649 5.127-2.357 11.845c-1.946 4.419-7.781 6.894-8.135 13.494 0 0 6.779-6.128 11.554-6.836.884-2.18 1.591-4.478 1.65-7.012.059-4.066-1.592-7.602-2.712-11.491 0 .059 0 0 0 0z"
					opacity="0.12"
				></path>
				<path
					fill="#7588BC"
					d="M119.572 251.251c-.177 2.063.884 4.066 2.652 5.186l5.129 3.123a4.299 4.299 0 004.656-.059l6.72-4.243c1.415-.942 2.358-2.474 2.476-4.183l1.591-21.096h-21.692l-1.532 21.272zM185.178 232.453v20.92a6.171 6.171 0 002.593 5.009l4.362 3.064a6.374 6.374 0 007.722-.295l6.425-5.244c1.886-1.532 2.947-3.831 2.83-6.247l-.59-17.265h-23.342v.058zM181.936 200.573l-.707 3.477 31.712 6.659-.589-4.243-30.416-5.893z"
				></path>
				<path
					fill="#D78C74"
					d="M139.36 142.645c3.522-1.062 5.119-6.091 3.567-11.232-1.552-5.142-5.665-8.448-9.187-7.386-3.522 1.063-5.119 6.092-3.567 11.233 1.552 5.141 5.665 8.448 9.187 7.385z"
				></path>
				<path
					fill="#381911"
					d="M155.057 77.414v-.177c-.058.118 0 .177 0 .177z"
				></path>
				<path
					fill="#E5A185"
					d="M198.913 129.86c-.236-12.492-2.358-28.285-5.128-37.537-2.24-12.08-36.487-17.089-46.213-.235-3.066 7.778-7.958 22.274-9.432 36.594v-.236s-8.547 38.185 25.347 39.835c33.952 1.709 37.312-16.205 35.426-38.421z"
				></path>
				<g opacity="0.38">
					<path
						fill="#E5A185"
						d="M150.108 122.317c-6.72.059-12.143 6.011-12.084 13.318.059 7.307 5.541 13.2 12.261 13.141 6.719-.059 12.142-6.011 12.083-13.318-.059-7.248-5.54-13.141-12.26-13.141z"
						opacity="0.38"
					></path>
					<path
						fill="#E5A084"
						d="M150.255 148.719c6.674-.045 12.045-5.964 11.996-13.222-.048-7.257-5.497-13.105-12.171-13.06-6.674.044-12.045 5.964-11.996 13.221.048 7.258 5.498 13.105 12.171 13.061z"
						opacity="0.38"
					></path>
					<path
						fill="#E59F83"
						d="M150.107 122.494c-6.661.059-11.966 5.952-11.907 13.141.059 7.189 5.482 13.023 12.083 13.023 6.661-.059 11.966-5.952 11.907-13.141-.058-7.248-5.481-13.023-12.083-13.023z"
						opacity="0.38"
					></path>
					<path
						fill="#E49E83"
						d="M150.255 148.542c6.576-.044 11.868-5.884 11.82-13.044-.048-7.16-5.418-12.928-11.994-12.884-6.576.044-11.868 5.884-11.82 13.043.048 7.16 5.417 12.929 11.994 12.885z"
						opacity="0.38"
					></path>
					<path
						fill="#E49D82"
						d="M150.105 122.67c-6.542.059-11.789 5.834-11.789 12.964.059 7.131 5.423 12.847 11.966 12.847 6.543-.059 11.789-5.834 11.789-12.964-.059-7.131-5.423-12.906-11.966-12.847z"
						opacity="0.38"
					></path>
					<path
						fill="#E49C81"
						d="M150.254 148.424c6.511-.044 11.751-5.83 11.703-12.925-.047-7.095-5.364-12.811-11.875-12.767-6.511.043-11.75 5.83-11.703 12.925.048 7.095 5.364 12.811 11.875 12.767z"
						opacity="0.38"
					></path>
					<path
						fill="#E49B80"
						d="M150.252 148.306c6.478-.043 11.692-5.777 11.645-12.807-.047-7.029-5.337-12.693-11.815-12.65-6.479.044-11.692 5.777-11.645 12.807.047 7.03 5.336 12.693 11.815 12.65z"
						opacity="0.38"
					></path>
					<path
						fill="#E49A80"
						d="M150.252 148.247c6.414-.043 11.575-5.75 11.528-12.747-.047-6.997-5.284-12.635-11.697-12.592-6.413.043-11.574 5.75-11.528 12.747.047 6.997 5.284 12.635 11.697 12.592z"
						opacity="0.38"
					></path>
					<path
						fill="#E3997F"
						d="M150.252 148.13c6.381-.043 11.516-5.697 11.47-12.629-.047-6.932-5.257-12.517-11.637-12.475-6.381.043-11.516 5.697-11.47 12.629.046 6.932 5.256 12.517 11.637 12.475z"
						opacity="0.38"
					></path>
					<path
						fill="#E3987E"
						d="M150.251 148.071c6.348-.043 11.457-5.67 11.411-12.57-.046-6.899-5.23-12.458-11.578-12.416-6.348.043-11.457 5.67-11.411 12.57.046 6.899 5.23 12.458 11.578 12.416z"
						opacity="0.38"
					></path>
					<path
						fill="#E3977D"
						d="M150.251 148.011c6.283-.042 11.34-5.642 11.294-12.509-.046-6.867-5.177-12.4-11.46-12.358-6.283.042-11.339 5.643-11.293 12.509.046 6.867 5.176 12.4 11.459 12.358z"
						opacity="0.38"
					></path>
					<path
						fill="#E3967C"
						d="M150.25 147.894c6.25-.042 11.281-5.59 11.235-12.392-.045-6.802-5.149-12.282-11.4-12.24-6.25.042-11.281 5.59-11.235 12.392.046 6.802 5.149 12.282 11.4 12.24z"
						opacity="0.38"
					></path>
					<path
						fill="#E2957C"
						d="M150.106 123.319c-6.189.059-11.2 5.54-11.141 12.316.059 6.777 5.129 12.198 11.318 12.198 6.189-.059 11.199-5.539 11.141-12.316-.059-6.776-5.129-12.198-11.318-12.198z"
						opacity="0.38"
					></path>
					<path
						fill="#E2947B"
						d="M150.249 147.717c6.186-.042 11.163-5.51 11.118-12.215-.045-6.704-5.095-12.105-11.281-12.063-6.185.041-11.163 5.51-11.118 12.214.045 6.704 5.096 12.105 11.281 12.064z"
						opacity="0.38"
					></path>
					<path
						fill="#E2937A"
						d="M150.249 147.658c6.12-.041 11.045-5.483 11.001-12.154-.045-6.672-5.042-12.047-11.162-12.007-6.121.041-11.046 5.483-11.002 12.154.045 6.672 5.043 12.048 11.163 12.007z"
						opacity="0.38"
					></path>
					<path
						fill="#E29279"
						d="M150.248 147.599c6.088-.041 10.987-5.456 10.942-12.095-.044-6.639-5.015-11.988-11.103-11.948-6.087.041-10.987 5.456-10.942 12.095.044 6.639 5.015 11.988 11.103 11.948z"
						opacity="0.38"
					></path>
					<path
						fill="#E29179"
						d="M150.248 147.482c6.055-.041 10.928-5.403 10.884-11.977-.044-6.574-4.988-11.871-11.043-11.83-6.055.04-10.928 5.402-10.884 11.976.043 6.575 4.988 11.871 11.043 11.831z"
						opacity="0.38"
					></path>
					<path
						fill="#E19078"
						d="M150.246 147.422c5.99-.04 10.811-5.375 10.767-11.916-.044-6.542-4.935-11.812-10.925-11.773-5.99.04-10.81 5.376-10.767 11.917.044 6.542 4.935 11.812 10.925 11.772z"
						opacity="0.38"
					></path>
					<path
						fill="#E18F77"
						d="M150.107 123.849c-5.954.059-10.728 5.363-10.728 11.845.059 6.482 4.892 11.726 10.846 11.667 5.953-.059 10.728-5.362 10.728-11.844 0-6.482-4.893-11.727-10.846-11.668z"
						opacity="0.38"
					></path>
					<path
						fill="#E18E76"
						d="M150.246 147.246c5.924-.04 10.693-5.296 10.65-11.739-.044-6.444-4.882-11.636-10.807-11.596-5.925.039-10.693 5.295-10.65 11.739.044 6.444 4.882 11.636 10.807 11.596z"
						opacity="0.38"
					></path>
					<path
						fill="#E18D75"
						d="M150.244 147.186c5.893-.039 10.635-5.268 10.592-11.68-.043-6.411-4.855-11.577-10.747-11.537-5.892.039-10.634 5.268-10.592 11.68.043 6.411 4.855 11.577 10.747 11.537z"
						opacity="0.38"
					></path>
					<path
						fill="#E18C75"
						d="M150.244 147.068c5.827-.039 10.517-5.215 10.474-11.561-.042-6.346-4.8-11.459-10.628-11.42-5.827.039-10.517 5.215-10.474 11.561.042 6.346 4.801 11.459 10.628 11.42z"
						opacity="0.38"
					></path>
					<path
						fill="#E08B74"
						d="M150.105 124.145c-5.776.058-10.433 5.185-10.433 11.49.059 6.306 4.774 11.373 10.551 11.373 5.777-.058 10.433-5.185 10.433-11.49-.059-6.306-4.774-11.373-10.551-11.373z"
						opacity="0.38"
					></path>
					<path
						fill="#E08A73"
						d="M150.243 146.892c5.762-.039 10.399-5.135 10.357-11.384-.041-6.249-4.746-11.283-10.508-11.245-5.763.039-10.4 5.136-10.358 11.384.041 6.249 4.746 11.283 10.509 11.245z"
						opacity="0.38"
					></path>
					<path
						fill="#E08972"
						d="M150.243 146.833c5.697-.038 10.282-5.108 10.24-11.324-.041-6.216-4.693-11.224-10.39-11.186-5.697.038-10.282 5.108-10.24 11.324.041 6.216 4.693 11.224 10.39 11.186z"
						opacity="0.38"
					></path>
					<path
						fill="#E08872"
						d="M150.242 146.774c5.664-.037 10.223-5.081 10.182-11.264-.042-6.184-4.667-11.166-10.332-11.128-5.664.038-10.223 5.081-10.181 11.264.041 6.184 4.666 11.166 10.331 11.128z"
						opacity="0.38"
					></path>
					<path
						fill="#DF8771"
						d="M150.105 124.498c-5.599.059-10.138 5.008-10.138 11.137.059 6.128 4.656 11.078 10.256 11.019 5.6-.059 10.139-5.008 10.139-11.137-.059-6.128-4.657-11.078-10.257-11.019z"
						opacity="0.38"
					></path>
					<path
						fill="#DF8670"
						d="M150.241 146.598c5.566-.038 10.046-5.001 10.006-11.087-.041-6.086-4.587-10.99-10.154-10.952-5.567.037-10.046 5.001-10.006 11.086.041 6.086 4.587 10.99 10.154 10.953z"
						opacity="0.38"
					></path>
					<path
						fill="#DF856F"
						d="M150.107 124.674c-5.541.059-10.021 4.95-9.962 11.02.059 6.01 4.539 10.901 10.08 10.843 5.541-.059 10.02-4.95 9.962-11.02 0-6.011-4.539-10.902-10.08-10.843z"
						opacity="0.38"
					></path>
					<path
						fill="#DF846F"
						d="M150.239 146.421c5.502-.037 9.93-4.921 9.89-10.91-.04-5.988-4.533-10.813-10.034-10.776-5.502.037-9.93 4.921-9.89 10.909.04 5.989 4.533 10.813 10.034 10.777z"
						opacity="0.38"
					></path>
					<path
						fill="#DF836E"
						d="M150.24 146.362c5.469-.037 9.871-4.894 9.831-10.85-.04-5.956-4.506-10.754-9.975-10.718-5.469.037-9.87 4.894-9.831 10.85.04 5.956 4.506 10.754 9.975 10.718z"
						opacity="0.38"
					></path>
					<path
						fill="#DE826D"
						d="M150.24 146.244c5.404-.036 9.753-4.841 9.714-10.731-.04-5.891-4.453-10.637-9.857-10.601-5.404.036-9.753 4.841-9.713 10.731.039 5.891 4.452 10.637 9.856 10.601z"
						opacity="0.38"
					></path>
					<path
						fill="#DE816C"
						d="M150.238 146.185c5.372-.035 9.695-4.813 9.656-10.671-.039-5.858-4.425-10.578-9.797-10.543-5.371.036-9.694 4.814-9.655 10.672.039 5.858 4.425 10.578 9.796 10.542z"
						opacity="0.38"
					></path>
					<path
						fill="#DE806B"
						d="M150.237 146.067c5.339-.036 9.636-4.761 9.597-10.554-.039-5.793-4.398-10.46-9.737-10.424-5.339.035-9.636 4.76-9.597 10.553.039 5.793 4.398 10.461 9.737 10.425z"
						opacity="0.38"
					></path>
					<path
						fill="#DE7F6B"
						d="M150.106 125.146c-5.305.059-9.549 4.715-9.49 10.49.059 5.775 4.362 10.371 9.667 10.371 5.305-.059 9.549-4.714 9.49-10.489-.059-5.775-4.362-10.372-9.667-10.372z"
						opacity="0.38"
					></path>
					<path
						fill="#DE7E6A"
						d="M150.106 125.263c-5.246.059-9.491 4.714-9.432 10.43.059 5.716 4.303 10.313 9.55 10.254 5.246-.059 9.49-4.714 9.431-10.43 0-5.716-4.303-10.313-9.549-10.254z"
						opacity="0.38"
					></path>
					<path
						fill="#DD7D69"
						d="M150.236 145.831c5.209-.035 9.401-4.654 9.363-10.317-.038-5.663-4.291-10.225-9.5-10.19-5.209.035-9.4 4.653-9.363 10.316.038 5.663 4.291 10.225 9.5 10.191z"
						opacity="0.38"
					></path>
					<path
						fill="#DD7C68"
						d="M150.235 145.773c5.176-.035 9.342-4.627 9.304-10.258-.037-5.63-4.264-10.166-9.44-10.131-5.176.034-9.342 4.627-9.304 10.257.037 5.63 4.264 10.166 9.44 10.132z"
						opacity="0.38"
					></path>
					<path
						fill="#DD7B68"
						d="M150.235 145.654c5.111-.034 9.224-4.573 9.187-10.138-.037-5.565-4.211-10.049-9.322-10.015-5.111.034-9.224 4.573-9.187 10.138.037 5.565 4.21 10.049 9.322 10.015z"
						opacity="0.38"
					></path>
					<path
						fill="#DD7A67"
						d="M150.105 125.559c-5.069.059-9.136 4.537-9.136 10.076.059 5.539 4.185 9.959 9.254 9.959 5.069-.059 9.196-4.537 9.137-10.077 0-5.539-4.185-9.958-9.255-9.958z"
						opacity="0.38"
					></path>
					<path
						fill="#DD7A66"
						d="M150.234 145.536c5.046-.033 9.107-4.519 9.07-10.019-.036-5.5-4.157-9.932-9.203-9.898-5.046.033-9.106 4.519-9.07 10.019.037 5.501 4.157 9.932 9.203 9.898z"
						opacity="0.38"
					></path>
					<path
						fill="#DC7965"
						d="M150.107 125.735c-5.011.059-9.019 4.479-8.96 9.9.059 5.422 4.126 9.841 9.137 9.782 5.01-.059 9.018-4.478 8.959-9.9-.059-5.421-4.126-9.782-9.136-9.782z"
						opacity="0.38"
					></path>
					<path
						fill="#DC7864"
						d="M150.233 145.36c4.949-.034 8.931-4.44 8.894-9.842-.036-5.403-4.076-9.756-9.025-9.722-4.948.033-8.93 4.439-8.894 9.841.036 5.403 4.077 9.756 9.025 9.723z"
						opacity="0.38"
					></path>
					<path
						fill="#DC7764"
						d="M150.105 125.912c-4.892.059-8.841 4.419-8.841 9.723.059 5.362 4.067 9.664 8.959 9.605 4.893-.059 8.842-4.42 8.842-9.723-.059-5.362-4.067-9.664-8.96-9.605z"
						opacity="0.38"
					></path>
					<path
						fill="#DC7663"
						d="M150.232 145.184c4.883-.033 8.813-4.36 8.778-9.665-.036-5.305-4.023-9.579-8.906-9.546-4.884.033-8.814 4.36-8.778 9.664.035 5.305 4.023 9.579 8.906 9.547z"
						opacity="0.38"
					></path>
					<path
						fill="#DB7562"
						d="M150.232 145.124c4.818-.032 8.696-4.332 8.66-9.604-.035-5.272-3.969-9.52-8.787-9.488-4.818.032-8.696 4.332-8.66 9.604.035 5.272 3.969 9.52 8.787 9.488z"
						opacity="0.38"
					></path>
					<path
						fill="#DB7461"
						d="M150.23 145.006c4.786-.032 8.637-4.279 8.602-9.486-.034-5.207-3.942-9.403-8.728-9.371-4.785.032-8.636 4.279-8.602 9.486.035 5.208 3.943 9.403 8.728 9.371z"
						opacity="0.38"
					></path>
					<path
						fill="#DB7361"
						d="M150.106 126.207c-4.716.059-8.547 4.243-8.547 9.428 0 5.186 3.89 9.311 8.665 9.311 4.715-.059 8.547-4.243 8.547-9.428 0-5.186-3.891-9.311-8.665-9.311z"
						opacity="0.38"
					></path>
					<path
						fill="#DB7260"
						d="M150.229 144.829c4.688-.031 8.461-4.199 8.426-9.308-.034-5.11-3.862-9.226-8.55-9.195-4.688.031-8.46 4.199-8.426 9.308.034 5.11 3.862 9.227 8.55 9.195z"
						opacity="0.38"
					></path>
					<path
						fill="#DB715F"
						d="M150.105 126.383c-4.656.059-8.429 4.184-8.37 9.251.059 5.068 3.832 9.134 8.488 9.134 4.657-.059 8.429-4.184 8.37-9.251 0-5.068-3.831-9.134-8.488-9.134z"
						opacity="0.38"
					></path>
					<path
						fill="#DA705E"
						d="M150.228 144.652c4.623-.031 8.343-4.119 8.31-9.131-.034-5.012-3.809-9.049-8.431-9.018-4.623.03-8.343 4.119-8.31 9.13.034 5.012 3.808 9.05 8.431 9.019z"
						opacity="0.38"
					></path>
					<path
						fill="#DA6F5D"
						d="M150.227 144.594c4.59-.031 8.284-4.092 8.251-9.072-.034-4.979-3.782-8.991-8.372-8.96-4.59.03-8.284 4.092-8.251 9.071.033 4.979 3.781 8.991 8.372 8.961z"
						opacity="0.38"
					></path>
					<path
						fill="#DA6E5D"
						d="M150.227 144.535c4.525-.03 8.167-4.065 8.134-9.012-.033-4.947-3.728-8.932-8.254-8.902-4.525.03-8.166 4.065-8.133 9.012.033 4.947 3.728 8.932 8.253 8.902z"
						opacity="0.38"
					></path>
					<path
						fill="#DA6D5C"
						d="M150.227 144.417c4.493-.03 8.108-4.012 8.076-8.893-.033-4.882-3.701-8.815-8.194-8.785-4.492.03-8.108 4.011-8.075 8.893.032 4.882 3.701 8.815 8.193 8.785z"
						opacity="0.38"
					></path>
					<path
						fill="#DA6C5B"
						d="M150.226 144.358c4.46-.029 8.049-3.985 8.017-8.834-.033-4.849-3.674-8.756-8.134-8.726-4.46.029-8.05 3.985-8.017 8.834.032 4.849 3.674 8.756 8.134 8.726z"
						opacity="0.38"
					></path>
					<path
						fill="#D96B5A"
						d="M150.225 144.24c4.395-.029 7.932-3.931 7.9-8.715-.032-4.784-3.62-8.639-8.015-8.609-4.395.029-7.932 3.931-7.9 8.715.032 4.784 3.621 8.639 8.015 8.609z"
						opacity="0.38"
					></path>
					<path
						fill="#D96A5A"
						d="M150.106 126.973c-4.362 0-7.899 3.889-7.84 8.662.059 4.773 3.596 8.603 7.958 8.545 4.362 0 7.899-3.89 7.84-8.663 0-4.714-3.596-8.544-7.958-8.544z"
						opacity="0.38"
					></path>
					<path
						fill="#D96959"
						d="M150.226 144.123c4.329-.029 7.814-3.878 7.782-8.597-.031-4.719-3.567-8.521-7.897-8.492-4.33.028-7.814 3.877-7.782 8.596.031 4.719 3.567 8.522 7.897 8.493z"
						opacity="0.38"
					></path>
					<path
						fill="#D96858"
						d="M150.223 144.005c4.298-.029 7.756-3.825 7.725-8.479-.031-4.654-3.54-8.403-7.837-8.375-4.297.029-7.756 3.825-7.725 8.479.031 4.654 3.54 8.403 7.837 8.375z"
						opacity="0.38"
					></path>
					<path
						fill="#D86757"
						d="M150.224 143.946c4.232-.028 7.638-3.798 7.607-8.419-.031-4.621-3.487-8.345-7.719-8.316-4.232.028-7.638 3.797-7.607 8.418.031 4.622 3.487 8.345 7.719 8.317z"
						opacity="0.38"
					></path>
					<path
						fill="#D86657"
						d="M150.222 143.828c4.199-.028 7.579-3.744 7.549-8.301-.031-4.556-3.46-8.227-7.659-8.199-4.2.028-7.58 3.745-7.549 8.301.03 4.556 3.459 8.227 7.659 8.199z"
						opacity="0.38"
					></path>
					<path
						fill="#D86556"
						d="M150.223 143.768c4.167-.028 7.52-3.717 7.49-8.241-.03-4.524-3.433-8.168-7.6-8.141-4.167.028-7.52 3.718-7.49 8.241.03 4.524 3.433 8.169 7.6 8.141z"
						opacity="0.38"
					></path>
					<path
						fill="#D86455"
						d="M150.221 143.71c4.102-.028 7.403-3.691 7.373-8.182-.03-4.491-3.379-8.11-7.481-8.082-4.102.027-7.403 3.69-7.373 8.181.03 4.491 3.379 8.11 7.481 8.083z"
						opacity="0.38"
					></path>
					<path
						fill="#D86354"
						d="M150.107 127.562c-4.067 0-7.368 3.653-7.309 8.073.059 4.419 3.36 8.014 7.427 7.955 4.067 0 7.368-3.654 7.309-8.073 0-4.42-3.36-7.955-7.427-7.955z"
						opacity="0.38"
					></path>
					<path
						fill="#D76253"
						d="M150.22 143.533c4.037-.027 7.286-3.61 7.256-8.004-.029-4.393-3.325-7.933-7.362-7.906-4.037.027-7.285 3.611-7.256 8.004.029 4.394 3.326 7.933 7.362 7.906z"
						opacity="0.38"
					></path>
					<path
						fill="#D76153"
						d="M150.22 143.416c3.972-.027 7.168-3.557 7.139-7.886-.029-4.328-3.272-7.816-7.244-7.789-3.971.027-7.168 3.557-7.139 7.885.029 4.329 3.272 7.816 7.244 7.79z"
						opacity="0.38"
					></path>
					<path
						fill="#D76052"
						d="M150.219 143.356c3.939-.026 7.109-3.53 7.08-7.826-.029-4.296-3.245-7.757-7.184-7.731-3.939.026-7.109 3.53-7.081 7.826.029 4.296 3.246 7.757 7.185 7.731z"
						opacity="0.38"
					></path>
					<path
						fill="#D75F51"
						d="M150.219 143.297c3.907-.026 7.051-3.503 7.022-7.767-.028-4.263-3.218-7.698-7.125-7.672-3.906.026-7.05 3.503-7.022 7.767.029 4.263 3.219 7.698 7.125 7.672z"
						opacity="0.38"
					></path>
					<path
						fill="#D75E50"
						d="M150.218 143.18c3.874-.026 6.991-3.45 6.963-7.649-.028-4.198-3.191-7.58-7.065-7.554-3.874.025-6.992 3.45-6.964 7.648.028 4.198 3.192 7.581 7.066 7.555z"
						opacity="0.38"
					></path>
					<path
						fill="#D65D50"
						d="M150.106 128.033c-3.831 0-6.897 3.418-6.838 7.602 0 4.184 3.125 7.484 6.956 7.484 3.831 0 6.897-3.418 6.838-7.602 0-4.125-3.124-7.484-6.956-7.484z"
						opacity="0.38"
					></path>
					<path
						fill="#D65C4F"
						d="M150.106 128.151c-3.773 0-6.838 3.359-6.779 7.484 0 4.125 3.124 7.425 6.897 7.425 3.772 0 6.837-3.359 6.778-7.484 0-4.125-3.124-7.484-6.896-7.425z"
						opacity="0.38"
					></path>
					<path
						fill="#D65B4E"
						d="M150.106 128.21c-3.713 0-6.719 3.359-6.719 7.425s3.065 7.366 6.837 7.307c3.714 0 6.72-3.359 6.72-7.425-.059-4.066-3.065-7.307-6.838-7.307z"
						opacity="0.38"
					></path>
					<path
						fill="#D65A4D"
						d="M150.218 142.885c3.678-.025 6.639-3.316 6.612-7.352-.027-4.035-3.031-7.287-6.71-7.262-3.679.024-6.639 3.316-6.612 7.351.027 4.036 3.031 7.288 6.71 7.263z"
						opacity="0.38"
					></path>
					<path
						fill="#D5594C"
						d="M150.216 142.767c3.646-.024 6.58-3.263 6.553-7.233-.026-3.971-3.003-7.17-6.65-7.145-3.646.024-6.58 3.262-6.553 7.233.026 3.97 3.003 7.169 6.65 7.145z"
						opacity="0.38"
					></path>
					<path
						fill="#D5584C"
						d="M150.214 142.708c3.614-.024 6.522-3.236 6.496-7.174-.027-3.938-2.977-7.111-6.591-7.087-3.613.025-6.521 3.237-6.495 7.174.026 3.938 2.977 7.111 6.59 7.087z"
						opacity="0.38"
					></path>
					<path
						fill="#D5574B"
						d="M150.107 128.563c-3.596 0-6.425 3.182-6.425 7.072 0 3.889 2.947 7.012 6.484 7.012 3.595 0 6.425-3.182 6.425-7.071 0-3.89-2.889-7.072-6.484-7.013z"
						opacity="0.38"
					></path>
					<path
						fill="#D5564A"
						d="M150.106 128.622c-3.536 0-6.366 3.182-6.366 7.012 0 3.831 2.889 6.954 6.425 6.895 3.537 0 6.366-3.182 6.366-7.012 0-3.831-2.888-6.895-6.425-6.895z"
						opacity="0.38"
					></path>
					<path
						fill="#D55549"
						d="M150.214 142.473c3.483-.024 6.286-3.129 6.261-6.937-.026-3.808-2.87-6.876-6.353-6.852-3.484.023-6.287 3.128-6.262 6.936.026 3.808 2.87 6.876 6.354 6.853z"
						opacity="0.38"
					></path>
					<path
						fill="#D45449"
						d="M150.212 142.354c3.451-.023 6.228-3.076 6.203-6.818-.025-3.743-2.843-6.758-6.294-6.735-3.451.023-6.228 3.076-6.203 6.818.025 3.743 2.843 6.758 6.294 6.735z"
						opacity="0.38"
					></path>
					<path
						fill="#D45348"
						d="M150.212 142.296c3.386-.023 6.111-3.049 6.086-6.759-.025-3.71-2.79-6.699-6.175-6.677-3.386.023-6.111 3.049-6.086 6.759.025 3.71 2.79 6.7 6.175 6.677z"
						opacity="0.38"
					></path>
					<path
						fill="#D45247"
						d="M150.213 142.178c3.353-.023 6.051-2.996 6.027-6.641-.025-3.645-2.763-6.582-6.116-6.559-3.353.022-6.051 2.995-6.027 6.64.024 3.645 2.762 6.582 6.116 6.56z"
						opacity="0.38"
					></path>
				</g>
				<g opacity="0.38">
					<path
						fill="#E5A185"
						d="M190.96 145.991c5.873-4.375 7.086-12.682 2.709-18.553-4.376-5.871-12.685-7.084-18.558-2.709-5.873 4.376-7.087 12.682-2.71 18.553s12.686 7.084 18.559 2.709z"
						opacity="0.38"
					></path>
					<path
						fill="#E5A084"
						d="M186.908 147.899c6.938-2.133 10.834-9.486 8.7-16.423-2.134-6.936-9.488-10.83-16.427-8.697-6.939 2.133-10.834 9.485-8.701 16.422 2.134 6.936 9.489 10.831 16.428 8.698z"
						opacity="0.38"
					></path>
					<path
						fill="#E59F83"
						d="M185.457 148.21c7.105-1.325 11.791-8.156 10.466-15.259-1.325-7.103-8.158-11.788-15.263-10.463-7.105 1.324-11.791 8.156-10.466 15.259 1.324 7.102 8.158 11.787 15.263 10.463z"
						opacity="0.38"
					></path>
					<path
						fill="#E49E83"
						d="M187.073 147.676c6.809-2.219 10.53-9.536 8.311-16.344-2.22-6.807-9.539-10.527-16.349-8.309-6.81 2.219-10.531 9.537-8.311 16.344 2.219 6.808 9.539 10.528 16.349 8.309z"
						opacity="0.38"
					></path>
					<path
						fill="#E49D82"
						d="M185.064 148.082c7.041-1.113 11.848-7.721 10.735-14.761-1.113-7.04-7.724-11.845-14.766-10.732-7.041 1.113-11.848 7.721-10.735 14.761 1.113 7.04 7.724 11.844 14.766 10.732z"
						opacity="0.38"
					></path>
					<path
						fill="#E49C81"
						d="M190.58 145.776c5.752-4.156 7.044-12.187 2.887-17.937-4.157-5.751-12.191-7.043-17.943-2.887-5.752 4.156-7.044 12.187-2.887 17.937 4.157 5.751 12.19 7.043 17.943 2.887z"
						opacity="0.38"
					></path>
					<path
						fill="#E49B80"
						d="M195.782 135.57c.099-7.029-5.522-12.807-12.553-12.905-7.031-.098-12.81 5.52-12.909 12.549-.098 7.029 5.522 12.807 12.554 12.905 7.031.098 12.81-5.52 12.908-12.549z"
						opacity="0.38"
					></path>
					<path
						fill="#E49A80"
						d="M184.781 147.897c6.935-.949 11.787-7.339 10.837-14.272-.95-6.933-7.341-11.783-14.276-10.834-6.935.95-11.787 7.34-10.837 14.273.95 6.932 7.341 11.783 14.276 10.833z"
						opacity="0.38"
					></path>
					<path
						fill="#E3997F"
						d="M190.233 145.655c5.685-3.968 7.076-11.793 3.106-17.477-3.97-5.683-11.797-7.074-17.482-3.105-5.686 3.969-7.076 11.793-3.107 17.477 3.97 5.683 11.797 7.074 17.483 3.105z"
						opacity="0.38"
					></path>
					<path
						fill="#E3987E"
						d="M182.996 122.848c-6.897.059-12.437 5.657-12.437 12.551.059 6.895 5.658 12.434 12.555 12.434 6.897-.059 12.437-5.657 12.437-12.552 0-6.894-5.658-12.433-12.555-12.433z"
						opacity="0.38"
					></path>
					<path
						fill="#E3977D"
						d="M184.686 147.665c6.81-.903 11.597-7.154 10.694-13.961-.903-6.807-7.156-11.594-13.965-10.691-6.809.903-11.597 7.154-10.694 13.961.904 6.807 7.156 11.594 13.965 10.691z"
						opacity="0.38"
					></path>
					<path
						fill="#E3967C"
						d="M182.997 123.025c-6.837.059-12.319 5.598-12.26 12.434.059 6.835 5.6 12.316 12.437 12.257 6.838-.059 12.32-5.599 12.261-12.434-.059-6.836-5.6-12.316-12.438-12.257z"
						opacity="0.38"
					></path>
					<path
						fill="#E2957C"
						d="M184.095 147.556c6.747-.574 11.751-6.508 11.177-13.253-.575-6.745-6.51-11.747-13.257-11.173-6.747.574-11.751 6.508-11.176 13.253.574 6.745 6.509 11.747 13.256 11.173z"
						opacity="0.38"
					></path>
					<path
						fill="#E2947B"
						d="M192.056 143.505c4.495-4.976 4.105-12.652-.872-17.146-4.976-4.494-12.655-4.103-17.15.872-4.495 4.975-4.105 12.651.872 17.145 4.976 4.494 12.655 4.104 17.15-.871z"
						opacity="0.38"
					></path>
					<path
						fill="#E2937A"
						d="M188.921 145.914c5.835-3.239 7.939-10.594 4.698-16.427-3.24-5.833-10.596-7.936-16.431-4.697-5.835 3.239-7.938 10.594-4.698 16.427 3.24 5.833 10.596 7.936 16.431 4.697z"
						opacity="0.38"
					></path>
					<path
						fill="#E29279"
						d="M183.576 147.348c6.634-.291 11.777-5.904 11.486-12.536-.291-6.633-5.905-11.774-12.539-11.483-6.635.291-11.777 5.903-11.487 12.536.291 6.632 5.905 11.773 12.54 11.483z"
						opacity="0.38"
					></path>
					<path
						fill="#E29179"
						d="M189.416 145.411c5.557-3.516 7.211-10.869 3.694-16.424-3.517-5.555-10.873-7.209-16.429-3.693-5.557 3.516-7.211 10.869-3.694 16.425 3.517 5.555 10.872 7.208 16.429 3.692z"
						opacity="0.38"
					></path>
					<path
						fill="#E19078"
						d="M183.45 147.183c6.54-.215 11.668-5.689 11.453-12.227-.215-6.539-5.691-11.665-12.231-11.45-6.54.214-11.668 5.689-11.453 12.227.215 6.538 5.691 11.665 12.231 11.45z"
						opacity="0.38"
					></path>
					<path
						fill="#E18F77"
						d="M182.998 123.614c-6.484.059-11.73 5.362-11.671 11.844.059 6.482 5.364 11.727 11.848 11.668 6.484-.059 11.73-5.362 11.671-11.845-.059-6.482-5.364-11.726-11.848-11.667z"
						opacity="0.38"
					></path>
					<path
						fill="#E18E76"
						d="M191.843 143.04c4.235-4.858 3.73-12.228-1.129-16.462-4.859-4.235-12.231-3.73-16.467 1.128-4.235 4.857-3.73 12.228 1.129 16.462s12.231 3.729 16.467-1.128z"
						opacity="0.38"
					></path>
					<path
						fill="#E18D75"
						d="M182.997 123.791c-6.425.058-11.553 5.244-11.495 11.667.059 6.423 5.247 11.55 11.672 11.491 6.425-.059 11.553-5.244 11.494-11.668-.059-6.364-5.246-11.549-11.671-11.49z"
						opacity="0.38"
					></path>
					<path
						fill="#E18C75"
						d="M191.17 143.491c4.489-4.487 4.489-11.763 0-16.25s-11.766-4.487-16.255 0c-4.489 4.487-4.489 11.763 0 16.25 4.489 4.488 11.766 4.488 16.255 0z"
						opacity="0.38"
					></path>
					<path
						fill="#E08B74"
						d="M189.865 144.541c5.072-3.762 6.133-10.923 2.37-15.993-3.764-5.071-10.926-6.131-15.998-2.369-5.073 3.762-6.133 10.923-2.37 15.993 3.764 5.071 10.926 6.131 15.998 2.369z"
						opacity="0.38"
					></path>
					<path
						fill="#E08A73"
						d="M194.354 135.966c.319-6.24-4.483-11.557-10.726-11.876-6.242-.318-11.561 4.482-11.879 10.723-.319 6.24 4.483 11.558 10.726 11.876 6.242.319 11.561-4.482 11.879-10.723z"
						opacity="0.38"
					></path>
					<path
						fill="#E08972"
						d="M188.369 145.28c5.479-2.94 7.536-9.763 4.596-15.24-2.941-5.477-9.766-7.534-15.244-4.594-5.479 2.94-7.537 9.763-4.596 15.24 2.94 5.476 9.765 7.533 15.244 4.594z"
						opacity="0.38"
					></path>
					<path
						fill="#E08872"
						d="M182.998 124.204c-6.189.059-11.14 5.067-11.081 11.255.058 6.187 5.069 11.137 11.258 11.078 6.189-.059 11.141-5.068 11.082-11.255-.059-6.187-5.069-11.137-11.259-11.078z"
						opacity="0.38"
					></path>
					<path
						fill="#DF8771"
						d="M191.142 142.935c4.182-4.467 3.95-11.478-.518-15.659-4.468-4.181-11.481-3.95-15.664.517-4.183 4.468-3.951 11.478.517 15.66 4.469 4.181 11.482 3.95 15.665-.518z"
						opacity="0.38"
					></path>
					<path
						fill="#DF8670"
						d="M190.734 143.247c4.36-4.248 4.449-11.225.2-15.583-4.249-4.358-11.228-4.447-15.587-.199-4.36 4.248-4.449 11.224-.2 15.582 4.249 4.358 11.228 4.448 15.587.2z"
						opacity="0.38"
					></path>
					<path
						fill="#DF856F"
						d="M193.898 136.511c.619-5.989-3.736-11.346-9.727-11.964-5.991-.618-11.349 3.736-11.967 9.724-.619 5.989 3.736 11.345 9.727 11.964 5.991.618 11.349-3.736 11.967-9.724z"
						opacity="0.38"
					></path>
					<path
						fill="#DF846F"
						d="M190.587 143.155c4.302-4.166 4.412-11.03.245-15.331-4.167-4.302-11.034-4.411-15.336-.245-4.303 4.166-4.413 11.03-.245 15.331 4.167 4.302 11.033 4.411 15.336.245z"
						opacity="0.38"
					></path>
					<path
						fill="#DF836E"
						d="M182.998 124.616c-5.954.059-10.728 4.891-10.669 10.842.059 5.952 4.892 10.725 10.846 10.666 5.953-.059 10.728-4.891 10.669-10.842-.059-5.952-4.893-10.725-10.846-10.666z"
						opacity="0.38"
					></path>
					<path
						fill="#DE826D"
						d="M182.997 124.675c-5.894.059-10.669 4.832-10.61 10.725.059 5.892 4.834 10.666 10.728 10.607 5.895-.059 10.669-4.832 10.61-10.725 0-5.893-4.833-10.607-10.728-10.607z"
						opacity="0.38"
					></path>
					<path
						fill="#DE816C"
						d="M188.717 144.319c4.949-3.135 6.419-9.688 3.282-14.636-3.137-4.948-9.692-6.417-14.641-3.281-4.949 3.136-6.419 9.689-3.282 14.637 3.137 4.947 9.692 6.416 14.641 3.28z"
						opacity="0.38"
					></path>
					<path
						fill="#DE806B"
						d="M193.296 137.662c1.253-5.655-2.317-11.256-7.974-12.509-5.658-1.253-11.26 2.316-12.513 7.972-1.254 5.655 2.316 11.256 7.974 12.509 5.657 1.253 11.259-2.316 12.513-7.972z"
						opacity="0.38"
					></path>
					<path
						fill="#DE7F6B"
						d="M190.515 142.639c4.022-4.125 3.936-10.729-.191-14.749-4.127-4.02-10.732-3.935-14.754.191-4.021 4.125-3.935 10.729.191 14.749 4.127 4.02 10.733 3.935 14.754-.191z"
						opacity="0.38"
					></path>
					<path
						fill="#DE7E6A"
						d="M191.758 141.006c3.111-4.81 1.732-11.23-3.08-14.34-4.812-3.11-11.234-1.731-14.345 3.079-3.11 4.811-1.731 11.231 3.081 14.341 4.811 3.109 11.234 1.731 14.344-3.08z"
						opacity="0.38"
					></path>
					<path
						fill="#DD7D69"
						d="M186.365 145.057c5.36-1.83 8.221-7.659 6.39-13.017-1.832-5.359-7.662-8.219-13.022-6.388-5.36 1.831-8.221 7.659-6.39 13.018 1.832 5.358 7.662 8.218 13.022 6.387z"
						opacity="0.38"
					></path>
					<path
						fill="#DD7C68"
						d="M182.998 125.205a10.238 10.238 0 00-10.139 10.253 10.239 10.239 0 0010.257 10.136 10.238 10.238 0 0010.138-10.254 10.124 10.124 0 00-10.256-10.135z"
						opacity="0.38"
					></path>
					<path
						fill="#DD7B68"
						d="M187.162 144.549c5.083-2.27 7.362-8.23 5.09-13.311-2.271-5.081-8.232-7.359-13.315-5.089-5.082 2.271-7.361 8.231-5.09 13.312 2.271 5.081 8.233 7.359 13.315 5.088z"
						opacity="0.38"
					></path>
					<path
						fill="#DD7A67"
						d="M186.199 144.865c5.255-1.735 8.109-7.401 6.373-12.655-1.735-5.254-7.403-8.106-12.658-6.371-5.255 1.735-8.109 7.401-6.373 12.654 1.735 5.254 7.403 8.107 12.658 6.372z"
						opacity="0.38"
					></path>
					<path
						fill="#DD7A66"
						d="M192.378 138.882c1.932-5.15-.678-10.891-5.829-12.822-5.151-1.932-10.894.677-12.826 5.827-1.932 5.149.678 10.89 5.829 12.821 5.151 1.932 10.893-.677 12.826-5.826z"
						opacity="0.38"
					></path>
					<path
						fill="#DC7965"
						d="M186.998 144.356c4.978-2.185 7.241-7.99 5.056-12.967-2.186-4.976-7.993-7.239-12.971-5.054-4.977 2.185-7.241 7.99-5.055 12.966 2.185 4.977 7.992 7.24 12.97 5.055z"
						opacity="0.38"
					></path>
					<path
						fill="#DC7864"
						d="M182.997 125.618a9.797 9.797 0 00-9.726 9.841 9.798 9.798 0 009.844 9.723 9.798 9.798 0 009.726-9.841c0-5.421-4.421-9.782-9.844-9.723z"
						opacity="0.38"
					></path>
					<path
						fill="#DC7764"
						d="M184.584 144.885c5.272-.845 8.86-5.802 8.015-11.072-.845-5.27-5.804-8.858-11.075-8.013-5.272.845-8.86 5.802-8.015 11.072.845 5.271 5.804 8.858 11.075 8.013z"
						opacity="0.38"
					></path>
					<path
						fill="#DC7663"
						d="M185.725 144.567c5.097-1.477 8.031-6.804 6.555-11.899-1.477-5.096-6.806-8.029-11.903-6.553s-8.031 6.804-6.555 11.899c1.477 5.095 6.806 8.029 11.903 6.553z"
						opacity="0.38"
					></path>
					<path
						fill="#DB7562"
						d="M192.31 137.709c1.284-5.113-1.822-10.299-6.937-11.583-5.115-1.284-10.303 1.821-11.587 6.934-1.284 5.114 1.822 10.3 6.937 11.584a9.55 9.55 0 0011.587-6.935z"
						opacity="0.38"
					></path>
					<path
						fill="#DB7461"
						d="M186.487 144.14c4.851-1.897 7.245-7.366 5.348-12.215-1.898-4.85-7.369-7.243-12.22-5.346-4.851 1.897-7.245 7.366-5.347 12.215 1.897 4.85 7.368 7.243 12.219 5.346z"
						opacity="0.38"
					></path>
					<path
						fill="#DB7361"
						d="M189.671 141.991a9.367 9.367 0 000-13.25c-3.661-3.659-9.595-3.659-13.255 0a9.367 9.367 0 000 13.25c3.66 3.659 9.594 3.659 13.255 0z"
						opacity="0.38"
					></path>
					<path
						fill="#DB7260"
						d="M182.997 126.089c-5.128.059-9.255 4.184-9.196 9.31.059 5.127 4.186 9.252 9.314 9.193 5.128-.059 9.254-4.184 9.195-9.31 0-5.068-4.185-9.193-9.313-9.193z"
						opacity="0.38"
					></path>
					<path
						fill="#DB715F"
						d="M182.998 126.207c-5.069.059-9.137 4.184-9.137 9.251.059 5.068 4.185 9.134 9.255 9.134 5.069-.059 9.136-4.184 9.136-9.252 0-5.126-4.185-9.192-9.254-9.133z"
						opacity="0.38"
					></path>
					<path
						fill="#DA705E"
						d="M189.461 141.783a9.073 9.073 0 000-12.834 9.079 9.079 0 00-12.837 0 9.073 9.073 0 000 12.834 9.079 9.079 0 0012.837 0z"
						opacity="0.38"
					></path>
					<path
						fill="#DA6F5D"
						d="M189.285 141.881a9.015 9.015 0 00.275-12.748 9.022 9.022 0 00-12.752-.275 9.015 9.015 0 00-.275 12.748c3.445 3.596 9.154 3.719 12.752.275z"
						opacity="0.38"
					></path>
					<path
						fill="#DA6E5D"
						d="M184.744 144.135c4.859-.932 8.043-5.626 7.111-10.484-.932-4.858-5.628-8.041-10.487-7.109-4.86.932-8.044 5.626-7.112 10.484a8.96 8.96 0 0010.488 7.109z"
						opacity="0.38"
					></path>
					<path
						fill="#DA6D5C"
						d="M188.394 142.392a8.837 8.837 0 001.674-12.387 8.843 8.843 0 00-12.391-1.674 8.836 8.836 0 00-1.674 12.387 8.842 8.842 0 0012.391 1.674z"
						opacity="0.38"
					></path>
					<path
						fill="#DA6C5B"
						d="M185.275 143.842a8.78 8.78 0 006.283-10.711 8.784 8.784 0 00-16.998 4.43c1.223 4.693 6.021 7.505 10.715 6.281z"
						opacity="0.38"
					></path>
					<path
						fill="#D96B5A"
						d="M183.056 144.003c4.785 0 8.665-3.878 8.665-8.662 0-4.784-3.88-8.662-8.665-8.662a8.663 8.663 0 100 17.324z"
						opacity="0.38"
					></path>
					<path
						fill="#D96A5A"
						d="M183.057 143.944a8.605 8.605 0 100-17.207 8.605 8.605 0 100 17.207z"
						opacity="0.38"
					></path>
					<path
						fill="#D96959"
						d="M185.024 143.654a8.544 8.544 0 10-3.957-16.624 8.543 8.543 0 103.957 16.624z"
						opacity="0.38"
					></path>
					<path
						fill="#D96858"
						d="M183.122 143.77a8.428 8.428 0 10-.124-16.854 8.428 8.428 0 10.124 16.854z"
						opacity="0.38"
					></path>
					<path
						fill="#D86757"
						d="M182.997 127.032a8.401 8.401 0 00-8.311 8.427 8.4 8.4 0 008.429 8.308 8.402 8.402 0 008.311-8.426 8.289 8.289 0 00-8.429-8.309z"
						opacity="0.38"
					></path>
					<path
						fill="#D86657"
						d="M182.997 127.091c-4.598.059-8.253 3.771-8.253 8.309.059 4.596 3.773 8.25 8.311 8.191 4.598-.059 8.253-3.772 8.194-8.309.059-4.538-3.655-8.191-8.252-8.191z"
						opacity="0.38"
					></path>
					<path
						fill="#D86556"
						d="M185.414 143.187a8.19 8.19 0 10-4.746-15.679 8.19 8.19 0 104.746 15.679z"
						opacity="0.38"
					></path>
					<path
						fill="#D86455"
						d="M182.997 127.267c-4.479.059-8.075 3.713-8.075 8.191.059 4.479 3.713 8.073 8.193 8.073 4.48-.059 8.076-3.712 8.076-8.191 0-4.478-3.714-8.132-8.194-8.073z"
						opacity="0.38"
					></path>
					<path
						fill="#D86354"
						d="M188.711 141.033a8.014 8.014 0 000-11.334 8.02 8.02 0 00-11.337 0 8.012 8.012 0 000 11.334 8.018 8.018 0 0011.337 0z"
						opacity="0.38"
					></path>
					<path
						fill="#D76253"
						d="M183.057 127.444c-4.362 0-7.899 3.595-7.899 8.014 0 4.361 3.596 7.897 8.017 7.897 4.362 0 7.898-3.595 7.898-8.015-.058-4.419-3.654-7.955-8.016-7.896z"
						opacity="0.38"
					></path>
					<path
						fill="#D76153"
						d="M183.057 127.503c-4.362 0-7.84 3.595-7.84 7.896 0 4.361 3.595 7.838 7.898 7.838 4.362 0 7.84-3.595 7.84-7.897-.059-4.36-3.595-7.837-7.898-7.837z"
						opacity="0.38"
					></path>
					<path
						fill="#D76052"
						d="M185.68 142.676a7.777 7.777 0 004.683-9.954 7.78 7.78 0 00-9.957-4.682 7.777 7.777 0 00-4.683 9.954 7.781 7.781 0 009.957 4.682z"
						opacity="0.38"
					></path>
					<path
						fill="#D75F51"
						d="M183.055 127.679c-4.244 0-7.662 3.477-7.662 7.72s3.477 7.661 7.721 7.661 7.663-3.477 7.663-7.72c0-4.302-3.477-7.719-7.722-7.661z"
						opacity="0.38"
					></path>
					<path
						fill="#D75E50"
						d="M188.647 140.493a7.6 7.6 0 00-.476-10.74 7.606 7.606 0 00-10.743.476 7.6 7.6 0 00.476 10.74 7.606 7.606 0 0010.743-.476z"
						opacity="0.38"
					></path>
					<path
						fill="#D65D50"
						d="M183.056 127.857c-4.185 0-7.486 3.418-7.486 7.602s3.419 7.484 7.604 7.484c4.185 0 7.486-3.418 7.486-7.602-.059-4.184-3.477-7.543-7.604-7.484z"
						opacity="0.38"
					></path>
					<path
						fill="#D65C4F"
						d="M183.056 127.916c-4.126 0-7.427 3.359-7.427 7.484s3.36 7.425 7.486 7.425c4.126 0 7.427-3.359 7.427-7.484-.059-4.125-3.419-7.425-7.486-7.425z"
						opacity="0.38"
					></path>
					<path
						fill="#D65B4E"
						d="M186.093 142.062a7.365 7.365 0 003.666-9.751 7.368 7.368 0 00-9.754-3.665 7.365 7.365 0 00-3.666 9.751 7.37 7.37 0 009.754 3.665z"
						opacity="0.38"
					></path>
					<path
						fill="#D65A4D"
						d="M188.21 140.533a7.305 7.305 0 000-10.334 7.312 7.312 0 00-10.337 0 7.307 7.307 0 000 10.334 7.31 7.31 0 0010.337 0z"
						opacity="0.38"
					></path>
					<path
						fill="#D5594C"
						d="M190.237 135.639a7.19 7.19 0 00-6.941-7.431 7.19 7.19 0 10-.492 14.37 7.19 7.19 0 007.433-6.939z"
						opacity="0.38"
					></path>
					<path
						fill="#D5584C"
						d="M186.11 141.784a7.128 7.128 0 003.368-9.505 7.132 7.132 0 00-9.507-3.366 7.128 7.128 0 00-3.368 9.504 7.132 7.132 0 009.507 3.367z"
						opacity="0.38"
					></path>
					<path
						fill="#D5574B"
						d="M183.057 128.328c-3.89 0-7.014 3.182-7.014 7.071 0 3.89 3.183 7.013 7.073 7.013 3.891 0 7.015-3.182 7.015-7.071-.059-3.89-3.183-7.013-7.074-7.013z"
						opacity="0.38"
					></path>
					<path
						fill="#D5564A"
						d="M183.056 128.387c-3.832 0-6.956 3.182-6.897 7.012 0 3.83 3.183 6.954 7.015 6.895 3.831 0 6.955-3.182 6.896-7.013-.059-3.771-3.183-6.894-7.014-6.894z"
						opacity="0.38"
					></path>
					<path
						fill="#D55549"
						d="M188.031 140.132a6.892 6.892 0 00-.215-9.748 6.9 6.9 0 00-9.752.216 6.893 6.893 0 00.216 9.748 6.897 6.897 0 009.751-.216z"
						opacity="0.38"
					></path>
					<path
						fill="#D45449"
						d="M183.057 128.564a6.705 6.705 0 00-6.72 6.836 6.705 6.705 0 006.837 6.718 6.705 6.705 0 006.72-6.836c-.059-3.712-3.124-6.718-6.837-6.718z"
						opacity="0.38"
					></path>
					<path
						fill="#D45348"
						d="M186.386 141.182a6.717 6.717 0 10-6.691-11.652 6.716 6.716 0 00-2.482 9.171 6.721 6.721 0 009.173 2.481z"
						opacity="0.38"
					></path>
					<path
						fill="#D45247"
						d="M183.057 128.741c-3.655 0-6.602 3.006-6.602 6.659 0 3.654 3.006 6.6 6.661 6.6s6.602-3.005 6.602-6.659c-.059-3.653-3.006-6.6-6.661-6.6z"
						opacity="0.38"
					></path>
				</g>
				<path
					fill="#E5A185"
					d="M206.045 123.613c-3.477-1.178-7.604 2.004-9.195 7.131-1.592 5.126-.059 10.253 3.419 11.432 3.477 1.178 7.604-2.004 9.195-7.131 1.651-5.126.118-10.253-3.419-11.432z"
				></path>
				<path
					fill="#D78C74"
					d="M206.692 135.635c-3.301 2.181-6.896 1.591-9.549-.471.177 4.302-.589 12.434-6.602 20.86-4.833 6.777-15.443 9.134-23.401 9.016-18.921-.353-23.991-6.01-28.058-13.73 2.829 8.486 9.549 16.323 24.403 17.03 27.587 1.356 34.955-10.253 35.721-26.635.295.236.649.412 1.061.53 3.478 1.179 7.604-2.003 9.196-7.13.412-1.296.589-2.652.648-3.889a9.058 9.058 0 01-3.419 4.419z"
				></path>
				<path
					fill="#D78C74"
					d="M200.504 132.983l3.183.412c-.118-5.008 3.537-6.717 3.537-6.717-6.013-2.063-6.72 6.305-6.72 6.305z"
				></path>
				<path
					fill="#4F372D"
					d="M169.677 75.823c-35.014 3.064-29.119 41.78-29.119 41.78 1.827-11.609 8.782-26.046 14.264-26.459 0 0 4.893 3.83 12.025 3.83 6.425 0 15.208-4.832 15.208-4.832 6.425-.294 14.147 19.387 15.326 35.357.295 3.653 3.36-.648 3.36-.648s3.183-51.975-31.064-49.028z"
				></path>
				<path
					fill="#4F372D"
					d="M188.068 78.475c-10.728-15.556-44.386-10.312-44.386-10.312-2.889 17.973 9.726 21.803 9.726 21.803s29.119-5.834 33.599-2.77c4.479 3.006 13.616 27.932 13.616 27.932s6.956-26.34 1.238-35.828c-4.185-7.012-13.793-.825-13.793-.825z"
				></path>
				<path
					fill="#4F372D"
					d="M156.648 64.273c.177 2.358 2.24 4.715 2.24 4.715s35.898 23.335 29.119 9.487c-6.778-13.79-31.359-14.202-31.359-14.202z"
				></path>
				<path
					fill="#4F372D"
					d="M193.666 73.584c-2.004.354-2.417 1.297-2.417 1.297 1.356-2.652.295-6.188.295-6.188-3.832 2.299-3.419 5.422-3.419 5.422-1.945-4.007-7.84-5.127-7.84-5.127.236 3.3 3.832 6.6 4.067 6.659l3.124 4.596 6.308-1.12-.708-2.828c1.002-1.414.59-2.71.59-2.71z"
				></path>
				<path
					fill="#422E26"
					d="M144.919 81.834c-10.257 3.359-6.425 44.255-6.425 44.255 1.827-11.609 10.846-34.532 16.327-34.944 0 0-5.128-2.947-9.902-9.311z"
				></path>
				<path
					fill="#E5912F"
					d="M197.851 76.177c-1.238.235-2.594.589-3.95.883-3.242.825-6.719 1.356-10.079 1.002-3.891-.471-7.369-2.121-10.846-3.771-1.769-.825-3.537-1.71-5.364-2.475-3.891-1.591-8.488-3.123-12.733-2.888-2.122.118-4.185.825-6.071 1.65a13.31 13.31 0 00-4.303 3.006c-.471.471-.825.942-1.179 1.414.118 1.414.295 2.71.59 3.83.118-.118.294-.236.412-.353.708-.53 1.592-1.061 2.594-1.532 1.002-.413 2.181-.825 3.478-.943 5.069-.472 9.785 1.414 14.382 3.24 1.887.708 3.832 1.592 5.836 2.417 2.004.825 4.126 1.59 6.366 2.18 3.714 1.06 8.193 1.296 11.966.177.53-.177 1.002-.295 1.474-.413 1.945-.648 3.595-1.473 5.069-2.239 1.473-.766 2.711-1.473 3.772-2.062.767-.413 1.415-.648 2.063-.884-1.002-1.238-2.24-1.886-3.477-2.24z"
					opacity="0.11"
				></path>
				<path
					fill="#E5A185"
					d="M162.662 131.392s-5.011-3.536-6.72 2.829c-1.651 6.364 11.082 9.9 14.441 3.241 3.36-6.659-5.894-18.916-5.894-18.916s1.886 7.602-1.827 12.846z"
				></path>
				<path
					fill="#fff"
					d="M162.662 131.392s-4.892-3.3-6.543 2.416c2.594.59 5.246.943 7.899 1.061 1.532-3.83 1.945-7.955 2.004-12.434-.354-.118-.707-.177-1.061-.294.118 2.651-.177 6.246-2.299 9.251z"
					opacity="0.2"
				></path>
				<path
					fill="#4F372D"
					d="M200.8 124.852l-3.419.058c-.353 5.009-2.24 9.9-6.071 13.318-3.714 3.241-8.194 4.832-12.968 2.947-2.594-1.061-5.011-2.417-7.84-2.77-3.949-.53-9.667.707-13.322 1.827-5.364 1.709-9.902 1.532-13.38-3.477-1.12-1.591-2.063-3.3-2.947-5.009a48.555 48.555 0 01-1.769-4.007c-.118-.354-.648-1.237-.53-1.591-3.891 17.266-5.777 44.844 30.416 43.489 36.192-1.297 30.71-28.404 30.71-28.404-1.886-6.069 1.12-16.381 1.12-16.381zm-22.222 30.878c-1.828 1.355-3.95 1.355-5.777 0-1.297-.943-4.126-2.534-6.189-2.534-2.24 0-4.539 1.591-5.895 2.534-1.886 1.237-4.657.943-6.071-.707-1.769-2.122-1.415-4.479.766-6.188 2.947-2.298 6.72-3.889 11.082-4.007 4.539-.118 9.136 2.121 12.143 4.832 1.945 1.827 2.122 4.42-.059 6.07z"
				></path>
				<path
					fill="#D78C74"
					d="M155.883 135.988c.825 5.186 11.494 7.484 14.5 1.473.177-.353.354-.766.413-1.178-4.951 1.178-10.139.943-14.913-.295z"
				></path>
				<path
					fill="#fff"
					d="M183.528 121.139c-6.661-.472-8.96 5.775-8.96 5.775s1.12 4.183 8.076 4.183c7.368 0 7.84-5.067 7.84-5.067s-.354-4.361-6.956-4.891zM143.857 125.087s-.059 4.655 6.367 4.891c7.427.295 8.016-2.004 8.016-2.004s-7.191-13.965-14.383-2.887z"
				></path>
				<path
					fill="url(#paint0_linear)"
					d="M153.701 122.73c-1.533-.471-3.419 1.12-4.244 3.595-.295.943-.413 2.298-.118 3.594.294.059.53.059.825.059 1.65.059 2.947 0 4.008-.118.531-.53.708-1.296.884-1.709.767-2.474.177-4.891-1.355-5.421z"
				></path>
				<path
					fill="#fff"
					d="M148.514 126.972l.235 1.061s4.362-.354 3.95-2.357c-.413-2.063-4.185 1.296-4.185 1.296z"
					opacity="0.77"
				></path>
				<path
					fill="url(#paint1_linear)"
					d="M183.469 122.788c-1.533-.471-3.419 1.061-4.244 3.418-.413 1.297-.295 3.477.294 4.597.885.176 1.887.353 3.066.353.884-.412 1.886-2.18 2.24-3.182.825-2.416.235-4.714-1.356-5.186z"
				></path>
				<path
					fill="#fff"
					d="M178.282 128.092l-.118 1.06s4.598-.176 4.185-2.121c-.412-1.945-4.067 1.061-4.067 1.061z"
					opacity="0.77"
				></path>
				<path
					fill="#381911"
					d="M150.636 119.194c-5.658 0-6.837 5.893-6.837 5.893s1.12-2.475 6.189-2.652c5.069-.176 8.193 5.363 8.193 5.363s.118-8.604-7.545-8.604z"
				></path>
				<path
					fill="#422E26"
					d="M145.566 111.946l.472 2.592c8.193-5.716 16.151-5.067 16.151-5.067l.354-6.365c-12.379 2.063-16.977 8.84-16.977 8.84zM175.334 103.106l-1.355 5.657s10.786.354 16.976 6.365l1.002-2.475s-4.834-7.131-16.623-9.547z"
				></path>
				<path
					fill="#381911"
					d="M183.114 119.547c-7.073-.707-8.665 7.072-8.665 7.072s1.886-3.89 8.547-3.713c5.895.177 7.427 3.182 7.427 3.182s-.117-5.892-7.309-6.541z"
				></path>
				<path
					fill="#E5A185"
					d="M88.331 160.031c-5.128 1.12-8.665 7.131-13.852 8.309.707.471.825 1.355 1.06 2.063 1.416 4.832-5.776 37.89-9.195 57.572-3.477 19.623 1.003 32.41 10.67 32.646 9.667.236 15.797-5.952 20.63-18.032 4.834-12.139-2.298-29.11-3.713-39.069-1.356-9.429-6.072-37.36-5.6-43.489z"
				></path>
				<path
					fill="#E5A185"
					d="M80.02 145.299c-3.301-1.709-6.13.354-9.55 1.061-3.418.707-10.315-2.475-13.498-3.536s-13.203-7.189-16.505-7.543c-3.3-.353-4.361.884-4.361.884-6.308-1.119-5.66 2.593-4.834 2.947.825.412 1.71.707 1.71.707-2.948.235-3.714 3.476-1.769 3.889 1.945.412 9.608 3.83 9.608 3.83-1.297.354-2.004 2.24-1.591 3.064.412.884 2.711.943 6.602 2.004 3.89 1.12 9.785 7.661 14.795 10.077 4.244 2.062 10.846 3.241 14.56 6.069 4.48-2.828 13.203-8.839 13.144-8.78 0 0-.118-4.42-.53-6.718-.413-2.239-4.48-6.246-7.781-7.955zM265.579 180.479c-.059-1.297 0-4.891 1.591-6.129-5.01-2.652-9.136-7.602-14.088-10.43 1.828 7.13-1.945 28.344-5.481 38.892-4.245 12.729-11.554 26.93-7.722 40.955 3.831 14.025 11.14 20.212 20.984 16.912 9.844-3.3 10.08-18.739 10.021-29.405.059-10.666-4.775-40.66-5.305-50.795z"
				></path>
				<path
					fill="#E5A185"
					d="M302.186 131.156c-2.417 1.768-3.419 4.125-3.419 4.125s-.826-.825-2.83 1.12c-2.004 2.003-4.951 6.659-4.951 6.659s-13.204 6.069-17.271 6.835c-4.067.707-11.318-1.002-15.031.825-3.714 1.827-7.545 6.954-5.541 13.259 0 0 8.606 8.309 13.145 11.668 5.776-8.486 22.517-18.032 28.117-21.332 0 0 .177-.472.884-1.297.707-.825 2.417-.648 3.949-3.535 1.533-2.888 5.482-14.673 7.309-17.502 1.828-2.828-1.945-2.652-4.361-.825z"
				></path>
				<path
					fill="#D78C74"
					d="M302.184 131.156c-2.122 1.533-3.124 3.536-3.36 4.008.884 2.239-.648 5.421-1.061 7.601-.766 3.889-1.238 8.368-3.536 11.609.059-.059.117-.059.176-.118 0 0 .177-.471.885-1.296.707-.825 2.416-.648 3.949-3.536 1.532-2.887 5.482-14.673 7.309-17.501 1.827-2.829-1.945-2.593-4.362-.767z"
					opacity="0.59"
				></path>
				<path
					fill="#D78C74"
					d="M36.4 136.284c-.177-.059-.294-.059-.294-.059l.294.059zM31.39 140.408c-1.533 1.002-1.65 3.006-.118 3.3 1.945.413 9.608 3.83 9.608 3.83s2.83-.648 6.602.354c0 0-14.913-4.95-16.033-5.834-1.002-.766-.295-1.473-.06-1.65zM31.39 136.695c-1.062.884-.59 2.24-.119 2.475.825.413 1.71.707 1.71.707 2.711.472 13.085 3.477 13.085 3.477s-12.968-4.419-14.029-5.068c-1.06-.648-.648-1.591-.648-1.591z"
					opacity="0.42"
				></path>
				<g fill="#D78C74" opacity="0.42">
					<path
						d="M38.345 135.281c-1.238.177-1.887.531-2.122.766l.117.177s7.31 2.416 12.556 4.42c-3.537-1.415-11.14-4.538-10.551-5.363zM50.782 141.409c-.59-.235-1.178-.471-1.827-.707 1.061.413 1.827.707 1.827.707z"
						opacity="0.42"
					></path>
				</g>
				<path
					fill="#fff"
					d="M63.34 146.124c-4.775.059-8.842 3.948-8.842 3.948-1.65 1.886 12.083-3.948 8.841-3.948z"
					opacity="0.09"
				></path>
				<path
					fill="#D78C74"
					d="M302.185 131.156c-2.417 1.768-3.419 4.125-3.419 4.125s-.589-.53-1.827.295c1.651 3.005-1.238 8.603-2.358 11.196-1.414 3.123-3.301 5.952-6.071 8.073-2.888 2.18-6.366 3.359-9.726 4.714-6.484 2.593-14.383 5.422-21.162 2.004-4.126-2.063-3.3-5.834-1.296-9.134-2.712 2.475-4.716 6.659-3.124 11.609 1.827 7.13-1.946 28.344-5.482 38.892-4.244 12.729-11.554 26.93-7.722 40.955 3.831 14.025 11.14 20.212 20.984 16.912 9.844-3.3 10.08-18.739 10.021-29.405-.059-10.666-4.833-40.66-5.423-50.795-.059-1.002 0-3.359.707-4.95 5.836-8.486 22.518-18.032 28.117-21.332 0 0 .177-.472.885-1.297.707-.825 2.416-.648 3.949-3.535 1.533-2.888 5.482-14.673 7.309-17.502 1.827-2.828-1.945-2.652-4.362-.825zm-35.426 112.14c-2.947 12.08-13.557 11.491-14.206-2.063-.648-13.553 4.067-35.71 5.954-51.267.589-5.009 3.242-3.83 5.01 0 1.827 3.83 6.189 41.249 3.242 53.33z"
					opacity="0.35"
				></path>
				<path
					fill="#D78C74"
					d="M290.985 143.059s-13.203 6.07-17.271 6.836c-4.067.707-11.317-1.002-15.031.825-.766.353-1.532.884-2.24 1.532v.177s3.066-1.591 7.192-1.709c6.071-.118 6.602 3.005 8.016 3.123 1.415.177 19.452-8.368 19.452-8.368s2.653-5.893 4.775-9.075c-1.945 1.945-4.893 6.659-4.893 6.659z"
					opacity="0.18"
				></path>
				<path
					fill="#D78C74"
					d="M88.33 160.031s-.117-4.42-.53-6.718c-.353-1.768-2.888-4.655-5.54-6.6 1.65 1.709 3.418 5.716-.944 6.894-2.004.531-1.002 4.95-9.844 4.715-6.601-.177-10.963-1.768-16.622-4.832-2.889-1.533-5.836-2.593-9.078-3.006-1.886-.235-7.191-.177-5.953-2.121-.53.707-.767 1.709-.472 2.298.413.884 2.712.943 6.602 2.004 3.89 1.119 9.785 7.66 14.795 10.076 4.009 1.945 10.08 3.123 13.853 5.598.707.472.825 1.356 1.06 2.063 1.415 4.832-5.776 37.89-9.195 57.572-3.478 19.623 1.002 32.41 10.67 32.646 9.666.236 15.796-5.952 20.63-18.032 4.834-12.139-2.299-29.11-3.714-39.069-1.473-9.428-6.189-37.36-5.717-43.488zm-16.799 77.843c-.118-12.905 4.067-37.655 6.661-51.208 1.179-6.129 5.128-6.482 5.482 1.178.354 7.661 3.183 27.048 5.482 46.966 1.768 14.378-17.507 14.437-17.625 3.064z"
					opacity="0.35"
				></path>
				<path
					fill="#7588BC"
					d="M140.499 168.163c-8.253 4.773-15.444 17.502-21.398 37.95-1.65 5.598-3.006 11.255-4.126 16.441-.059 6.423 0 13.258-.118 20.212 3.183-22.57 14.265-72.894 33.246-73.188v-.413c-2.358-.471-4.834-1.061-7.604-1.002zM219.897 228.976c-2.299-13.376-6.425-31.055-10.433-42.899-2.947-8.78-6.189-14.791-9.667-18.032-2.712-.059-5.305.412-7.545 1.061l.177.176c.118-.058.943-.707 2.358-.294 2.122.648 6.425 3.83 11.317 18.209 6.189 18.267 12.438 49.145 14.088 61.225.236-6.658-.472-13.494-.295-19.446z"
				></path>
				<path
					fill="#C77762"
					d="M176.513 153.49c-.825.766-2.181.943-3.183.295-2.122-1.297-5.01-2.711-7.014-2.711-2.122 0-4.48 1.297-6.131 2.357-.943.648-2.298.531-3.124-.177-1.061-.883-.943-2.357.177-3.123 2.063-1.414 5.423-3.182 9.019-3.182 3.595 0 7.486 2.063 9.844 3.477 1.179.707 1.355 2.121.412 3.064z"
				></path>
				<path
					fill="#000"
					d="M162.662 157.202s3.478-3.064 7.84-.236c0 0-.059 3.595-3.773 3.949-3.713.294-4.067-3.713-4.067-3.713z"
					opacity="0.16"
				></path>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear"
					x1="150.843"
					x2="154.39"
					y1="131.021"
					y2="121.559"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#5C3333"></stop>
					<stop offset="1"></stop>
				</linearGradient>
				<linearGradient
					id="paint1_linear"
					x1="180.216"
					x2="183.6"
					y1="132.635"
					y2="122.375"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#5C3333"></stop>
					<stop offset="1"></stop>
				</linearGradient>
				<clipPath id="clip-na">
					<path
						fill="#fff"
						d="M0 0H276.866V277.726H0z"
						transform="translate(30.152 64.273)"
					></path>
				</clipPath>
			</defs>
		</svg>
	);
}

export default NoAttempted;
